// extracted by mini-css-extract-plugin
module.exports = {"container":"mj","title":"mk","image":"ml","imageLogo":"mm","info":"mn","infoContainer":"mo","infoTitle":"mp","infoValue":"mq","goBack":"mr"};